import {observer} from 'mobx-react';
import {EmployeeNameWithAvatar} from 'shared/components';
import {FormattedMessage} from 'react-intl';
import UpdateDetail from './UpdateDetail';

const EventDetails = observer(({nmbrUpdate}) => {
  return (
    <div className='mb3'>
      <div className='h3 medium mb2'><FormattedMessage id='nmbr.updates.directory.Event'/></div>
      <div className='flex flex-wrap row-gap-2'>
        <UpdateDetail label='nmbr.updates.directory.What Happened'>
          <FormattedMessage id={`nmbr.updates.directory.event_types.${nmbrUpdate.eventType}`}/>
        </UpdateDetail>
        <UpdateDetail label='nmbr.updates.directory.Employee'>
          <EmployeeNameWithAvatar employee={nmbrUpdate.employee}/>
        </UpdateDetail>
      </div>
    </div>
  );
});

export default EventDetails;
